import { DestinationAPI } from '../../destinations/api/DestinationAPI';
import { FilterContentFieldDataTypes } from '../../filter/constants';
import { Filter } from '../../filter/interface';
import { PIPELINE_FILTER_STATUSES } from './pipeline-status';

export const DESTINATION_FILTER = {
  title: 'Destination',
  filterKey: 'destination_name',
  filterType: FilterContentFieldDataTypes.LIST,
  filterContentProps: {
    multiple: true,
    dataSource: () =>
      DestinationAPI.getDestinations().then(res =>
        res.data.map(destination => ({
          label: destination.name,
          value: destination.name,
          logo: {
            logo: destination.destination_type.logo_url,
            logoDarkMode: destination.destination_type.dark_mode_logo_url
          }
        }))
      ),
    textFieldProps: {
      forceActiveLegend: true,
      prefixIcon: 'search',
      placeholder: 'Search Destination'
    }
  }
};

export const PIPELINE_FILTERS: Filter[] = [
  DESTINATION_FILTER,
  {
    title: 'Status',
    filterKey: 'status',
    filterType: FilterContentFieldDataTypes.LIST,
    filterContentProps: {
      multiple: true,
      selectMode: true,
      options: PIPELINE_FILTER_STATUSES,
      textFieldProps: {
        forceActiveLegend: true,
        prefixIcon: 'search',
        placeholder: 'Search By Status'
      }
    }
  }
];
